/* cSpell:disable */
import { FooterConfig } from '@tenants/types/tenant';
import { EXP_COMMERCIAL_ROOT_DOMAIN, getSubDomainUrl } from 'constants/domains';
import { LOCALE_EXP_REALTY_US_PATHS } from 'types/locales';
import { ACCESSIBILITY_PATH } from 'constants/urls';
import { EXP_REALTY_US_FOOTER_DISCLOSURES } from '../../shared/exp-realty-us-footer-disclosures';

export function createFooterConfig(): FooterConfig {
  return {
    footerColumns: {
      column1: [
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_EXPLORE_EXP_LABEL,
            defaultValue: 'Explore eXp',
          },
          link: '/explore-exp',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_FIND_AGENT_LABEL,
            defaultValue: 'Find an Agent',
          },
          link: '/agents-search',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_JOIN_EXP_LABEL,
            defaultValue: 'Join eXp',
          },
          link: 'https://join.exprealty.com',
          isAnchor: true,
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_INVESTOR_RELATIONS_LABEL,
            defaultValue: 'Investor Relations',
          },
          link: 'https://expworldholdings.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_COMPANY_CAREERS_LABEL,
            defaultValue: 'Company Careers',
          },
          link: 'https://expworldholdings.com/careers/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_HOME_GUIDES_LABEL,
            defaultValue: 'Home Guides',
          },
          link: 'https://exprealty.com/guides/',
          isAnchor: true,
          target: '_blank',
        },
      ],
      column2: [
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_EXP_LIFE_LABEL,
            defaultValue: 'eXp Life',
          },
          link: 'https://life.exprealty.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_ZOOCASA_LABEL,
            defaultValue: 'Zoocasa',
          },
          link: 'https://zoocasa.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_SUCCESS_LABEL,
            defaultValue: 'SUCCESS®',
          },
          link: 'https://www.success.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_SUCCESS_LENDING_LABEL,
            defaultValue: 'SUCCESS® Lending',
          },
          link: 'https://www.successlending.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_REVENOS_LABEL,
            defaultValue: 'eXp Revenos',
          },
          link: 'https://revenos.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_COMMERCIAL_LABEL,
            defaultValue: 'eXp Commercial',
          },
          link: getSubDomainUrl(EXP_COMMERCIAL_ROOT_DOMAIN, 'www'),
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LUXURY_LABEL,
            defaultValue: 'eXp Luxury',
          },
          link: 'https://expluxury.com/?tl=en',
          target: 'blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LAND_AND_RANCH_LABEL,
            defaultValue: 'eXp Land and Ranch',
          },
          link: 'https://landandranch.exprealty.com/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_ACCESSIBILITY_LABEL,
            defaultValue: 'Accessibility',
          },
          link: ACCESSIBILITY_PATH,
          isAnchor: true,
          target: '_blank',
        },
      ],
      column3: [
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_TERMS_AND_CONDITIONS_LABEL,
            defaultValue: 'Terms and Conditions',
          },
          link: 'https://expworldholdings.com/terms-of-service/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_PRIVACY_RIGHTS_REQUEST_LABEL,
            defaultValue: 'Privacy Rights Request',
          },
          link: 'https://submit-irm.trustarc.com/services/validation/e6d7516d-df9c-4404-bd9f-21a2f0d2a6a4/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_PRIVACY_POLICY_LABEL,
            defaultValue: 'Privacy Policy',
          },
          link: 'https://expworldholdings.com/privacy-policy/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_COOKIE_POLICY_LABEL,
            defaultValue: 'Cookie Policy',
          },
          link: 'https://expworldholdings.com/cookie-policy/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_BRAND_GUIDELINES_LABEL,
            defaultValue: 'Brand Guidelines',
          },
          link: 'https://join.exprealty.com/brand/',
          target: '_blank',
        },
        {
          label: {
            key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_LEGAL_SITEMAP_LABEL,
            defaultValue: 'Sitemap',
          },
          link: '/sitemap',
          isAnchor: true,
          target: '_blank',
        },
      ],
      bottom: [
        ...EXP_REALTY_US_FOOTER_DISCLOSURES,
      ],
      joinUsLink: 'https://join.exprealty.com',
      footerImageData: {
        src: '/next/assets/images/exp-footer-pic-us.jpg',
        alt: {
          key: LOCALE_EXP_REALTY_US_PATHS.FOOTER_IMAGE_ALT,
          defaultValue: 'A group of people at an event are laughing and cheering, with one man enthusiastically greeting a seated couple in the front row.',
        },
      },
    },
    showAccessibilityLink: true,
  };
}
